import { RadioButtonGroup } from 'commons/components';
import useTranslationMarketing from 'domains/Marketing/hook/useTranslationMarketing';

interface RadioGroupFilter<T, TName> {
  name: TName;
  value: T;
  options: readonly T[];
  onChange: (name: TName, value: T) => void;
}

function RadioGroupFilter<T extends string, TName extends string>({
  name,
  options,
  value,
  onChange,
}: Readonly<RadioGroupFilter<T, TName>>) {
  const t = useTranslationMarketing(`coupons.filters.${name}`);
  const labelOptions = options.map((value) => ({
    value,
    label: t(value || 'all'),
  }));

  return (
    <RadioButtonGroup
      label={t('title')}
      name={name}
      options={labelOptions}
      onChange={({ name, value }) => onChange(name, value)}
      value={value}
      boldLabel
    />
  );
}

export default RadioGroupFilter;
